<div *ngIf="show" class="page-loading" [ngClass]="{ 'static': static }">
  <img src="assets/img/oval.svg" class="loading-icon" />
</div>